<template>
  <div class="page_addInvoice">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/invoiceSet'}">开票项目维护</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_employee_box" v-loading="tableLoading">
        <div class="p_employee_list">
          <el-form :rules="formRules" ref="invoiceForm" :model="formQuery" label-width="130px">
            <el-form-item label="法务主体:" prop="subjectOfLegalAffairsId">
              <el-select v-model="formQuery.subjectOfLegalAffairsId" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeLeg" :disabled="id!=''">
                <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务类型:" prop="businessTypeId">
              <el-select v-model="businessTypeId" placeholder="" size="small" style="width: 300px;" clearable filterable multiple>
                <el-option v-for="(item, index) in treeList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开票方式:" prop="billingMethod">
              <div class="f_form_box">
                <el-select v-model="formQuery.billingMethod" placeholder="" style="width:160px;" size="small" clearable class="mr10">
                  <el-option label="全额征税" :value="1"></el-option>
                  <el-option label="差额征税-差额开票" :value="2"></el-option>
                  <el-option label="差额征税-全额开票" :value="4"></el-option>
                </el-select>
                <el-select v-model="formQuery.taxRate" placeholder="" style="width:90px;" size="small" class="mr10">
                  <el-option v-for="(item,index) in restaurants" :key="index" :value="item"></el-option>
                </el-select>
                <el-input v-model="formQuery.otherTaxRate" size="small" placeholder="输入税率" clearable style="width:99px" :disabled="formQuery.taxRate!='其他'"></el-input>
                <span>%</span>
                <!-- <el-autocomplete class="inline-input" v-model="formQuery.taxRate" :fetch-suggestions="querySearch" placeholder="税率" @select="handleSelect" size="small" style="width:90px">
                  <template slot-scope="{ item }">
                    <div class="name">{{ item }}</div>
                  </template>
                </el-autocomplete>
                <span>%</span> -->
              </div>
            </el-form-item>
            <el-form-item label="开票项目内容:" class="i_width">
              <div class="dtl_table">
                <el-table class="post_list" border :data="formQuery.details">
                  <el-table-column align="center" label="税收分类编码" width="150px">
                    <template slot-scope="{row}">
                      <el-input v-model="row.taxClassificationCode" size="small" clearable></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="一级分类" min-width="150px" fit :show-overflow-tooltip="true">
                    <template slot-scope="{row}">
                      <el-input v-model="row.primaryClassification" size="small" clearable></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="开票品名" min-width="170px">
                    <template slot-scope="{row}">
                      <el-input v-model="row.invoicingName" size="small" clearable></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="适用票种" min-width="170px">
                    <template slot-scope="{$index}">
                      <el-select filterable v-model="ticketTypeSeList[$index].ticketTypeIds" placeholder="" size="small" clearable multiple v-if="ticketTypeSeList[$index]!=undefined">
                        <el-option v-for="(item,index) in ticketTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="指定项目可见" min-width="170px">
                    <template slot-scope="{row}">
                      <el-select filterable v-model="row.projectids" placeholder="" size="small" clearable multiple>
                        <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="允许合并" min-width="100px" v-if="formQuery.billingMethod==2">
                    <template slot-scope="{row}">
                      <el-select filterable v-model="row.isMerge" placeholder="" size="small" clearable>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="200px">
                    <template slot-scope="{row,$index}">
                      <el-button size="small" type="primary" @click="addHandle('details','ticketTypeSeList')">添加</el-button>
                      <!-- <el-button size="small" type="success" @click="editHandle(row)">编辑</el-button> -->
                      <el-button size="small" v-if="formQuery.details.length>1" type="warning" @click="dltHandle('details',$index,'ticketTypeSeList')">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>

            <el-form-item label="其他开票项目内容:" class="i_width" v-if="formQuery.billingMethod==2">
              <div class="dtl_table">
                <el-table class="post_list" border :data="formQuery.otherDetails">
                  <el-table-column align="center" label="税收分类编码" width="150px">
                    <template slot-scope="{row}">
                      <el-input v-model="row.taxClassificationCode" size="small" clearable></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="一级分类" min-width="150px" fit :show-overflow-tooltip="true">
                    <template slot-scope="{row}">
                      <el-input v-model="row.primaryClassification" size="small" clearable></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="开票品名" min-width="170px">
                    <template slot-scope="{row}">
                      <el-input v-model="row.invoicingName" size="small" clearable></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="适用票种" min-width="170px">
                    <template slot-scope="{row}">
                      <el-select filterable v-model="row.ticketTypeIds" placeholder="" size="small" clearable>
                        <el-option v-for="(item,index) in ticketTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="指定项目可见" min-width="170px">
                    <template slot-scope="{row}">
                      <el-select filterable v-model="row.projectids" placeholder="" size="small" clearable multiple>
                        <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="允许合并" min-width="100px" v-if="formQuery.billingMethod==2">
                    <template slot-scope="{row}">
                      <el-select filterable v-model="row.isMerge" placeholder="" size="small" clearable>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="200px">
                    <template slot-scope="{row,$index}">
                      <el-button size="small" type="primary" @click="addHandle('otherDetails','ticketTypeSeList2')">添加</el-button>
                      <!-- <el-button size="small" type="success" @click="editHandle(row)">编辑</el-button> -->
                      <el-button size="small" v-if="formQuery.otherDetails.length>1" type="warning" @click="dltHandle('otherDetails',$index,'ticketTypeSeList')">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
            <el-form-item label="是否启用:">
              <el-radio-group v-model="formQuery.status">
                <el-radio :label="0">启用</el-radio>
                <el-radio :label="1">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn_box">
          <el-button @click="backHandle">返回</el-button>
          <el-button type="primary" @click="saveHandle" :loading="isbtnLoading" :disabled="isSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <!-- 新增/修改弹框 -->
    <el-dialog :title="stateTitle" :visible.sync="updateVisible" width="500px" class="res_dialog income_dialog">
      <el-form :rules="updateRules" ref="updateForm" :model="updateQuery" label-width="110px">
        <el-form-item label="税收分类编码:">
          <el-input v-model="updateQuery.name1" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="一级分类:">
          <el-input v-model="updateQuery.name2" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="开票品名:">
          <el-input v-model="updateQuery.name3" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="适用票种:">
          <el-select v-model="updateQuery.name4" placeholder="" size="small">
            <el-option value="sss"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateVisible = false" size="small">取消</el-button>
        <el-button type="primary" size="small">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import xz from "@/common";
  import moment from "moment";
  export default {
    name: "updatePost",
    data() {
      return {
        id: '',
        pageTitle: "新增开票项目",
        formQuery: {
          subjectOfLegalAffairsId: "", //主体id
          businessTypeId: "",
          taxRate: "", //税率
          billingMethod: "", //开票方式 1：全额  2：差额  4差额征税-全额开票
          otherTaxRate: '', //其他税率
          status: 0, //状态
          details: [{
            taxClassificationCode: "", //税收分类编码
            primaryClassification: "", //一级分类
            invoicingName: "", //开票品名
            ticketTypeIds: "", //适用票种
            isMerge: "", //是否允许合并
            billingItemDetailsId: '',
            projectids: []
          }],
          otherDetails: [{
            taxClassificationCode: "",
            primaryClassification: "", //
            invoicingName: "", //
            ticketTypeIds: "", //
            isMerge: "", //
            billingItemDetailsId: '',
            projectids: []
          }],
          billingItemId: "", //开票项目id
          founder: Cookies.get("userid-b"), //创建人
        },
        ticketTypeList: [], //票种列表
        restaurants: ['1%', '3%', '5%', '6%', '9%', '11%', '13%', '其他'], //税率列表
        isbtnLoading: false,
        isSubmit: false,
        tableLoading: false,
        legList: [],
        businessTypeId: [], //业务类型
        isEdit: "dtl",
        // 详情参数
        dtlQuery: {
          mainuserid: "",
          useridr: "",
        },
        formRules: {
          subjectOfLegalAffairsId: {
            required: true,
            message: "请选择法务主体",
            trigger: "change",
          },
          businessTypeId: {
            required: true,
            message: "请选择业务类型",
            trigger: "change",
          },
          billingMethod: {
            required: true,
            message: "请选择开票方式",
            trigger: "change",
          },
        },
        updateRules: {},
        tableData: [],
        projectList: [], //项目列表
        updateQuery: {
          name1: "",
          name2: "",
          name3: "",
          name4: "",
        },
        stateTitle: "新增",
        updateVisible: false,
        treeList: [], //业务类型列表
        ticketTypeSeList: [{
          ticketTypeIds: []
        }],
        ticketTypeSeList2: [{
          ticketTypeIds: []
        }],
      };
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
        this.GetBillingItemEdit();
      }
      this.getlegalsubjectlist();
      this.getTreestr();
      this.GetFinancialProject();
    },
    methods: {
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          keyWord: '',
          pageSize: '10000'
        }
        xz.BasicFun(data, 'GetSubjectOfLegalAffairs').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data;
          } else {
            this.legList = [];
          }
        })
      },
      getTreestr() {
        let data = {
          pageSize: 100,
          keyWord: ''
        }
        xz.BasicFun(data, 'GetBusinessType').then(res => {
          if (res) {
            this.treeList = res.data;
            if (!this.id) {
              res.data.forEach(element => {
                this.businessTypeId.push(element.key)
              });
              // this.changegBT(this.businessTypeId)
            }
          } else {
            this.treeList = [];
          }
        })
      },
      GetBillingItemEdit() {
        xz.GetBillingItemEdit(this.id).then(res => {
          try {
            if (res.status == 'ok') {
              this.formQuery = res.data[0];
              if (this.formQuery.businessTypeId) {
                this.businessTypeId = this.formQuery.businessTypeId.split(',');
                // this.changegBT(this.businessTypeId)
              }
              this.GetTicketType(this.formQuery.subjectOfLegalAffairsId);
              this.formQuery.details.forEach(element => {
                element.projectids = element.projectids.map(Number)
              });
              if (this.formQuery.otherDetails != null) {
                this.formQuery.otherDetails.forEach(element => {
                  element.projectids = element.projectids.map(Number)
                });
              }
            } else {
              this.$message.error(res.msg)
            }
          } catch (e) {
            console.log(e)
            this.$message.error('系统出错')
          }
        })
      },
      // 人员详情
      getMemberDtl() {
        let that = this;
        this.tableLoading = true;
        xz.getauthJbUserDetail(this.dtlQuery).then((res) => {
          // console.log('res',res)
          if (res.status == "ok") {
            let resmsg = res.msg;
            let res1 = res.inforoledist;
            if (JSON.stringify(res1) == "{}") {
              this.tableData = [];
            } else {
              this.tableData = res1;
            }
          } else {
            console.log("获取详情出错");
          }
          this.tableLoading = false;
        });
      },
      // 添加
      addHandle(list, list2) {
        let dd = {
          ticketTypeIds: []
        }
        this[list2].push(dd);
        let query = {
          billingItemDetailsId: '',
          taxClassificationCode: "", //税收分类编码
          primaryClassification: "", //一级分类
          invoicingName: "", //开票品名
          ticketTypeIds: "", //适用票种
          isMerge: "", //是否允许合并
        }
        this.formQuery[list].push(query);
        this.stateTitle = "新增";
      },
      // 编辑
      editHandle(row) {
        this.updateVisible = true;
        this.updateQuery = {
          name1: row.namepro,
          name2: row.depart,
          name3: row.ticket,
          name4: row.remark,
        };
        this.stateTitle = "编辑";
      },
      // 删除
      dltHandle(list, index, list2) {
        this.formQuery[list].splice(index, 1);
        this[list2].splice(index, 1);
      },
      // 保存
      saveHandle() {
        if (this.id) {
          this.formQuery.billingItemId = this.id;
          this.formQuery.founder = Cookies.get("userid-b")
        }
        this.formQuery.businessTypeId = this.businessTypeId.toString();
        if (this.ticketTypeSeList.length > 0) {
          this.ticketTypeSeList.forEach((element, index) => {
            let sum = 0;
            element.ticketTypeIds.forEach((e, i) => {
              sum = sum + e
              if (i == element.ticketTypeIds.length - 1) {
                this.$set(this.formQuery.details[index], 'ticketTypeIds', sum)
              }
            });
          });
        }
        // if (this.formQuery.otherDetails != null && this.formQuery.otherDetails[0].ticketTypeIds == '') {
        //   this.formQuery.otherDetails = null;
        // }
        console.log(this.formQuery, this.ticketTypeSeList)
        this.isbtnLoading = true;
        xz.BasicFun(this.formQuery, 'SetBillingItemSave').then(res => {
          try {
            if (res.status == 'ok') {
              this.$message.success('保存成功！')
              this.isbtnLoading = false;
              this.isSubmit = true;
            } else {
              this.$message.error(res.msg);
              this.isbtnLoading = false;
            }
          } catch (e) {
            this.isbtnLoading = false;
            console.log(e)
          }
        })
      },
      // 取消
      backHandle() {
        this.$router.push({
          path: "/invoiceSet",
        });
      },
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          if (queryString) {
            return (restaurant == queryString);
          }
        };
      },
      handleSelect(item) {
        this.formQuery.taxRate = item;
      },
      changeLeg(val) {
        if (val) {
          this.GetTicketType(val)
        }
      },
      GetTicketType(val) {
        if (val) {
          let data = {
            keyWord: '',
            pageSize: 20,
            subjectOfLegalAffairsId: val
          }
          xz.BasicFun(data, 'GetTicketType').then(res => {
            try {
              if (res.status == 'ok') {
                this.ticketTypeList = res.data;
                if (this.id && this.ticketTypeList.length > 0) {
                  this.formQuery.details.forEach((element, index) => {
                    if (index != 0) {
                      let d = {
                        ticketTypeIds: []
                      }
                      this.ticketTypeSeList.push(d)
                    }
                    this.ticketTypeList.forEach(e => {
                      if (element.ticketTypeIds != null && this.judgeInclude(element.ticketTypeIds, e.key)) {
                        this.ticketTypeSeList[index].ticketTypeIds.push(e.key)
                      } else {
                        this.ticketTypeSeList[index].ticketTypeIds.push(null)
                      }
                    });
                  });
                }
              } else {
                this.ticketTypeList = [];
              }
            } catch (e) {
              console.log(e)
              this.$message.error('获取票种出错');
            }
          })
        }
      },
      //2的N次方
      // calculatePowerOfTwo(n) {
      //   n = n - 1;
      //   let result = 1;
      //   for (let i = 0; i < n; i++) {
      //     result *= 2;
      //   }
      //   return result;
      // },
      judgeInclude(c,n) {
        return c&n == 0 ? false : true;
      },
      //财务  获取项目列表
      GetFinancialProject() {
        let data = {
          searchVal: "",
          pageSize: 100000000,
          pageNum: 1,
        };
        xz.getplancomrecordprojectlist(data, '0383e791-72fd-4edc-aa70-2bcadminuser').then(
          (res) => {
            // console.log('项目名称列表', res)
            if (res.status == "ok") {
              this.projectList = res.data;
            } else {
              this.projectList = [];
            }
          }
        );
      },
    },
  };
</script>
<style scoped>
  .p_employee_list {
    background-color: #e8f7f7;
    padding: 10px 0;
  }

  .f_form_box {
    display: flex;
    align-content: center;
  }

  .mr10 {
    margin-right: 10px;
  }

  .btn_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .line_box {
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
  }

  .dtl_table {
    box-sizing: border-box;
    margin-top: 15px;
  }

  .emp_txt {
    width: 90px;
    text-align: right;
    font-size: 14px;
    color: #555;
    padding: 0 10px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .r_edit_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color: #000;
    border-bottom: 1px solid #dcdfe6;
  }

  .emp_form_txt {
    width: 370px;
    font-size: 14px;
    color: #000;
  }

  .txts01 {
    font-size: 14px;
  }

  .p_employee_item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 3px;
  }

  .p_employee_form.p_employee_form01 {
    margin-top: 0;
  }

  .p_employee_form {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .p_employee_box {
    background-color: #fff;
    padding: 15px 10px;
  }
</style>
<style>
  .page_addInvoice .el-input__icon {
    height: 32px;
    line-height: 32px;
  }
</style>